import { z } from 'zod';

export interface PaymentIframeDataType {
    customerId: number;
    data: {
        currency: string;
        amount: number;
        singleUseCustomerToken: string;
        customer: CustomerDataType;
        billingAddress: AddressDataType;
        merchantRefNum: string;
        simulator: 'EXTERNAL';
        environment: 'TEST' | 'LIVE';
        buttonColor: string;
        imageUrl: string;
        companyName: string;
        holderName: string;
        threeDs: ThreeDsDataType;
        displayPaymentMethods: string[];
        paymentMethodDetails: PaymentMethodDetailsDataType;
    };
}

interface CustomerDataType {
    locale: string;
    firstName: string;
    lastName: string;
    dateOfBirth: {
        year: number;
        month: number;
        day: number;
    };
    email: string;
    phone: string;
}

interface AddressDataType {
    nickName: string;
    street: string;
    street2?: string | null;
    city: string;
    zip: string;
    country: string;
    state: string;
}

interface ThreeDsDataType {
    merchantUrl: string;
    deviceChannel: string;
    messageCategory: string;
    transactionIntent: string;
    authenticationPurpose: string;
}

interface PaymentMethodDetailsDataType {
    card: {
        accountId: string;
    };
    applePay: {
        accountId: string;
        label: string;
        requestBillingAddress: boolean;
        type: 'pay';
        supportedCountries: string[];
        color: 'white' | 'black' | 'white-outline';
    };
}

export interface PaysafeInstanceType {
    isOpen: () => boolean;
    close: () => void;
    showSuccessScreen: (message: string) => void;
    showFailureScreen: (message: string) => void;
}

export const PaysafeError = z.object({
    code: z.string(),
    displayMessage: z.string(),
    message: z.string(),
    detailedMessage: z.string(),
    correlationId: z.string(),
});

export const PaysafeResult = z.object({
    paymentHandleToken: z.string(),
    paymentMethod: z.string(),
    customerOperation: z.string().optional().nullable(),
    amount: z.number(),
    transactionType: z.string().optional().nullable(),
});

export const PaysafeStage = z.enum([
    'PAYMENT_HANDLE_NOT_CREATED',
    'PAYMENT_HANDLE_CREATED',
    'PAYMENT_HANDLE_REDIRECT',
    'PAYMENT_HANDLE_PAYABLE',
]);

export const PaysafeExpired = z.boolean();
